// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".my-process-palette[data-v-ad2b6d86] {\n  box-sizing: border-box;\n  padding: 80px 20px 20px 20px;\n}\n.my-process-palette .test-button[data-v-ad2b6d86] {\n  box-sizing: border-box;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid rgba(24, 144, 255, 0.8);\n  cursor: pointer;\n}", ""]);
// Exports
module.exports = exports;
